import React from "react";
import { useParams } from "react-router-dom";
import { AdminStudentProfileHeader } from "./AdminStudentProfileHeader";
import { AdminSessions } from "../../sessions";
import { useGetUserQuery } from "../../../../../store/services/admin/UserService";

export const AdminStudentProfile = () => {
    const { id } = useParams();
    const { data: studentData, isLoading, isError } = useGetUserQuery({id});

    if (isLoading) return <div>Loading student details...</div>;
    if (isError) return <div>Failed to load student details.</div>;

    return (
        <div className="container py-4">
            <div className="row mb-4">
                <div className="col-12">
                    <AdminStudentProfileHeader student={studentData?.data?.data} />
                </div>
            </div>

            <div className="row">
                {/* <div className="col-lg-12 col-md-12 mb-4 mb-lg-0">
                    <AdminStudentAboutSection student={studentData?.data?.data} />
                </div> */}
                <h1>Sessions History</h1>
                <div className="col-lg-12 col-md-12">
                    <AdminSessions studentId={studentData?.data?.data?.id}/>
                </div>
            </div>
        </div>
    );
};
